import { Box, Grid, Stack, useTheme } from "@mui/material";
import TitleComponent from "../../../components/widgets/titleComponent";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import companyData from '../../../assets/data/company.json';
import { GetTheme, THEME } from "../../../theme/customThemeProvider";

const PlatformLayout = () => {
    const theme = useTheme();
    const {themeMode} = GetTheme();

    const {t} = useTranslation();

    return (
        <>
            <Box 
                className="sectionSpacing"
                width='100%'
                sx={{
                    backgroundColor: theme.palette.background.default
                }}
            >
                <Stack
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                    px='5%'
                >
                    <TitleComponent 
                        title={t('contact.platforms.title')}
                        description={t('contact.platforms.description')}
                    />

                    <Grid
                        direction='row'
                        justifyContent='center'
                        alignItems='center'
                        container
                        spacing={{xs: 2, md: 5}}
                    >
                        <Grid size={{xs: 4, md: 2.5}}>
                            <Link to={companyData.platforms.startupSL.link} target="_blank">
                                <img 
                                    src={
                                        themeMode === THEME.LIGHT
                                        ?
                                        companyData.platforms.startupSL.imageLight
                                        :
                                        companyData.platforms.startupSL.imageDark
                                    }
                                    alt="Startup SL" 
                                    width='100%'
                                />
                            </Link>
                        </Grid>

                         <Grid size={{xs: 4, md: 1.5}}>
                            <Link to={companyData.platforms.designRush.link} target="_blank">
                                <img 
                                    src={
                                        themeMode === THEME.LIGHT
                                        ?
                                        companyData.platforms.designRush.imageLight
                                        :
                                         companyData.platforms.designRush.imageDark
                                    }
                                    alt="Design Rush" 
                                    width='100%'
                                />
                            </Link>
                        </Grid>

                        <Grid size={{xs: 4, md: 1.5}}>
                            <Link to={companyData.platforms.crunchBase.link} target="_blank">
                                <img 
                                    src={
                                        themeMode === THEME.LIGHT
                                        ?
                                        companyData.platforms.crunchBase.imageLight
                                        :
                                         companyData.platforms.crunchBase.imageDark
                                    }
                                    alt="CrunchBase" 
                                    width='100%'
                                />
                            </Link>
                        </Grid>

                        <Grid size={{xs: 4, md: 1.5}}>
                            <Link to={companyData.platforms.berlin.link} target="_blank">
                                <img 
                                    src={
                                        themeMode === THEME.LIGHT
                                        ?
                                        companyData.platforms.berlin.imageLight
                                        :
                                         companyData.platforms.berlin.imageDark
                                    }
                                    alt="Berlin" 
                                    width='100%'
                                />
                            </Link>
                        </Grid>
                    </Grid>
                </Stack>
            </Box>
        </>
    );
}

export default PlatformLayout;